<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      &copy; 2026 <a href="/" class="footer-link">{{ $domain }}</a> This site is not affiliated with WhatsApp or Meta. APKs are from third-party sources for educational use only.
    </div>
    <div class="footer-links">
      <a href="/disclaimer/" class="footer-link">Disclaimer</a>
      |
      <a href="/privacy-policy/" class="footer-link">Privacy Policy</a>
      |
      <a href="/contact-us/" class="footer-link">Contact Us</a>
    </div>

  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer {
  // background-color: #282828;
  background-color: #fff;
  color: #121212;
  padding: 48px 0 24px;
}
@media (max-width: 768px) {
  .footer {
    padding: 40px 0 60px;
  }
}

.footer-container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.footer-links {
  display: flex;
  gap: 15px;
}

.footer-link {
  color: #1b3d76;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #2880ba;
}

.footer-note {
  font-size: 15px;

  p {
    margin: 0;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
  }

  .footer-links {
    justify-content: center;
    margin-bottom: 10px;
  }

  .footer-note {
    font-size: 10px;
  }
}
</style>
